import UserRole from "./userRole";

export default class User {

  id!: number;
  uuid!: string;
  firstName!: string;
  lastName!: string;
  fullName!: string;
  title!: string | null;
  email!: string;
  hasEmailAlert!: number;
  mav1Id!: number | null;
  notaryId!: number | null;
  image!: string | null;
  importedTs!: number | null;
  ip!: string;
  isActive!: boolean;
  isDeleted!: boolean;
  isEmailVerified!: boolean;
  isFirstAuth!: boolean;
  phone!: string;
  timezone!: string;
  userRoleId!: number;
  userRoleName!: string;
  activityStatus!: number;
  authLockedUntilTs!: number | null;
  bounceSubtype!: number | null;
  complaintSubtype!: number | null;
  dealerGroupId!: number | null;
  dealerGroupName!: string | null;
  dealerRegionId!: number | null;
  dealerRegionName!: string | null;
  dealerStoreId!: number | null;
  dealerStoreName!: string | null;
  tutorials!: {type: number, shouldShow: boolean}[];
  numOfFailedAuthAttempts!: number | null;
  numOfFailedVerifAttempts!: number | null;
  isImpersonated!: boolean;
  verifCodeConfirmedTs!: number;
  verifCodeCreatedTs!: number;
  passwdUpdatedTs!: number;
  lastActiveTs!: number;
  lastAuthTs!: number;
  createdTs!: number;
  updatedTs!: number;

  static ACTIVITY_STATUS_OFFLINE = 0;
  static ACTIVITY_STATUS_IDLE = 1;
  static ACTIVITY_STATUS_ACTIVE = 2;

  static EMAIL_ALERT_GENERAL = 'General';
  static EMAIL_ALERT_MAIL_BOX_FULL = 'MailboxFull';
  static EMAIL_ALERT_ON_ACCOUNT_SUPPRESION_LIST = 'OnAccountSuppresionList';

  getFullName(): string {
    return `${this.firstName || ''} ${this.lastName || ''}`.trim();
  }

  static getActivityStatusMap() {
    return {
      [this.ACTIVITY_STATUS_OFFLINE]: 'Offline',
      [this.ACTIVITY_STATUS_IDLE]: 'Idle',
      [this.ACTIVITY_STATUS_ACTIVE]: 'Active',
    };
  }

  static getActivityStatusName(id: number) {
    return this.getActivityStatusMap()[id];
  }

  /***** ROLES *****/

  isMasterAdmin(): boolean {
    return UserRole.isMasterAdmin(this.userRoleId!);
  }

  isAdmin(): boolean {
    return UserRole.isAdmin(this.userRoleId!);
  }

  isScheduler(): boolean {
    return UserRole.isScheduler(this.userRoleId!);
  }

  isDsc(): boolean {
    return UserRole.isDsc(this.userRoleId!);
  }

  isAccountManager(): boolean {
    return UserRole.isAccountManager(this.userRoleId!);
  }

  isLeadOps(): boolean {
    return UserRole.isLeadOps(this.userRoleId!);
  }

  isDealerGroupManager(): boolean {
    return UserRole.isDealerGroupManager(this.userRoleId!);
  }

  isDealerRegionalManager(): boolean {
    return UserRole.isDealerRegionalManager(this.userRoleId!);
  }

  isDealerStoreManager(): boolean {
    return UserRole.isDealerStoreManager(this.userRoleId!);
  }

  isDealerFinanceManager(): boolean {
    return UserRole.isDealerFinanceManager(this.userRoleId!);
  }

  isDealerSalesManager(): boolean {
    return UserRole.isDealerSalesManager(this.userRoleId!);
  }

  isDealerUpperManager(): boolean {
    return UserRole.isDealerUpperManager(this.userRoleId!);
  }

  isDealerLowerManager(): boolean {
    return UserRole.isDealerLowerManager(this.userRoleId!);
  }

  isDealerManager(): boolean {
    return UserRole.isDealerManager(this.userRoleId!);
  }

  isDealerStoreUser(): boolean {
    return UserRole.isDealerStoreUser(this.userRoleId!);
  }

  isDealerStoreLimitedUser(): boolean {
    return UserRole.isDealerStoreLimitedUser(this.userRoleId!);
  }

  isNotary(): boolean {
    return UserRole.isNotary(this.userRoleId!);
  }

  /***** ROLE TYPES *****/

  isAdminType(): boolean {
    return UserRole.isAdminType(this.userRoleId!);
  }

  isDealerType(): boolean {
    return UserRole.isDealerType(this.userRoleId!);
  }

  isNotaryType(): boolean {
    return UserRole.isNotaryType(this.userRoleId!);
  }
}